import { APP_CONFIG } from "../constants/global-variables.js";

export async function getSlotGames() {
  const url = `${window.location.origin}/slot_games.json`;
  try {
    const res = await axios.get(url);
    return res.data;
  } catch(err) {
    console.log('Error', err);
    return [];
  }
}

export async function register() {
  const url = `${APP_CONFIG.URL.apiBasePath}slots/register`;

  try {
    const res = await axios.post(
      url,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (err) {
    //console.log('Error getting documents', err);
  }
}

export async function goToGame() {
  const url = `${APP_CONFIG.URL.apiBasePath}slots/gotogame`;
  const aa = localStorage.getItem("access_token");
  try {
    const res = await axios.post(
      url,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (err) {
    //console.log('Error getting documents', err);
  }
}


export async function getHall() {
    const url = `${APP_CONFIG.URL.apiBasePath}slots/hall`;
    try {
        const res = await axios.get(url, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });

        return res.data;
    } catch (err) {
        //console.log('Error getting documents', err);
    }
}

//slotsfree/logout_initiate/{slot_id}
export async function signOut(slotId) {
  const keyCheck = localStorage.getItem("slot_game");
  if (keyCheck) localStorage.removeItem("slot_game");

  if (!slotId) return;

  const url = `${APP_CONFIG.URL.apiBasePath}slotsfree/logout_initiate/${slotId}`;
  try {
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "Content-Type": "application/json",
      },
    });

    return res.data;
  } catch (err) {
    //console.log('Error getting documents', err);
  }
}

export async function slotGame(gameName) {
  
  const url = `${window.location.origin}/casino/index?game=${gameName}&u=${localStorage.getItem("access_token")}`;
  try {
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "Content-Type": "application/json",
      },
    });

    return res.data;
  } catch (err) {
    //console.log('Error getting documents', err);
  }
}